const formService = { 
    USER_ID: 'user_Cv9Or6FaAr9dBlgkiVBHf', 
    TEMPLATE_ID: 'template_mty03lr',
    SERVICE_ID: 'service_ucpocop',
}

export default  formService;